export default "__VITE_ASSET__3pz4a933__"